
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../core/BaseButton";
import UIButton from "../core/components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnChestPlay extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 79.5, y ?? 85);

    // btn
    const btn = scene.add.image(0, 0, "common", "btn-play.png");
    this.add(btn);

    // lists
    const desktopVisibleList: Array<any> = [];
    const mobileVisibleList: Array<any> = [];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.desktopVisibleList = desktopVisibleList;
    thisUIButton.mobileVisibleList = mobileVisibleList;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 1000;

    this.desktopVisibleList = desktopVisibleList;
    this.mobileVisibleList = mobileVisibleList;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private desktopVisibleList: Array<any>;
  private mobileVisibleList: Array<any>;

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
